/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Assessment} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  questions: Assessment
}

const QuestionsInfoCell: FC<Props> = ({questions}) => {
  const {setItemIdForUpdate} = useListView()
  const openEditModal = () => {
    setItemIdForUpdate(questions.id)
  }

  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='d-flex flex-column'>
        <a
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {questions.title}
        </a>
      </div>
    </div>
  )
}

export {QuestionsInfoCell}
